<template>
  <div
    class="main-head-component"
    ref="main_head_component"
    :style="{transform: `translateY(-${get_scroll_top}px)`}"
    :class="main_head_component_classes">
    <div class="container">
      <div
        class="main_head">
        <logo-link
          v-if="!getIsMobile || !is_home_page"
          :green_logo="green_logo"
          change_mobile_logo
          class="main_head-logo"/>
        <inline-menu
          class="main_head-menu"
          :menus="header_menus"
        />
        <div class="main_head-side">
          <language-switcher
            ref="language_switcher"
            class="main_head-side_lang"
          />
        </div>
        <div class="main_head-mobile_burger mobile_menu_burger">
          <burger-menu
            shadow
            @click="showMobileMenu(!mobile_menu_shown)"/>
        </div>
        <mobile-menu
          v-if="getIsMobile"
          :shown="mobile_menu_shown"
          :menus="header_menus"
          @close="showMobileMenu(false)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ssr_document, ssr_window} from "../../helpers/ssr";
import LanguageSwitcher from "../small_parts/LanguageSwitcher.vue";
import LogoLink from "../small_parts/LogoLink.vue";
import InlineMenu from "../small_parts/InlineMenu.vue";
import BurgerMenu from "../small_parts/BurgerMenu.vue";
import MobileMenu from "../small_parts/MobileMenu.vue";
import {HEADER_COMPONENT_KEY} from "../../helpers/constants";

const BREAKPOINT_FIXED = 80
export default {
  name: 'MainHeadComponent',
  components: {
    MobileMenu,
    BurgerMenu,
    InlineMenu,
    LogoLink,
    LanguageSwitcher,
  },
  props: {
    /**props**/
    mobile_logo_green: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    green_logo() {
      return this.$context?.[HEADER_COMPONENT_KEY]?.mobile_logo_green || false;
    },
    header_menus() {
      return this.$context?.header_menu?.menus || []
    },
    is_home_page() {
      return !this.$context.route_to_home
    },
    scroll_over_breakpoint() {
      return this.scrolled_top >= BREAKPOINT_FIXED
    },
    get_scroll_top() {
      return this.scroll_over_breakpoint
        ? BREAKPOINT_FIXED
        : this.scrolled_top
    },
    main_head_component_classes() {
      return {
        shown_scroll: this.scroll_to_top,
        animated: this.scroll_over_breakpoint
      }
    }
  },
  beforeMount() {
    ssr_window.addEventListener('resize', this.pageResized)
  },
  mounted() {
    if (this.getIsMobile) return
    this.initScrollEvent()
  },
  data() {
    return {
      mobile_menu_shown: false,
      scrolled_top: 0,
      scroll_to_top: false,
    }
  },
  methods: {
    ...mapActions([
      'actionResolution'
    ]),
    initScrollEvent() {
      ssr_window.addEventListener('scroll', this.scrollEvent)
    },
    removeScrollEvent() {
      ssr_window.removeEventListener('scroll', this.scrollEvent)
    },
    scrollEvent({target}) {
      let scroll_top = target.scrollingElement?.scrollTop || 0
      this.scroll_to_top = this.scrolled_top > scroll_top
      this.scrolled_top = scroll_top
    },
    pageResized(e) {
      this.actionResolution(e.target.innerWidth)
    },
    showMobileMenu(bool) {
      this.mobile_menu_shown = bool
      bool ? this.initClickOutsideEvent() : this.removeClickOutsideEvent()
    },
    initClickOutsideEvent() {
      ssr_document.addEventListener('click', this.clickOutsideEvent)
    },
    removeClickOutsideEvent() {
      ssr_document.removeEventListener('click', this.clickOutsideEvent)
    },
    clickOutsideEvent({target}) {
      if (target.closest(`.main-head-component`)) return
      this.mobile_menu_shown = false
      this.removeClickOutsideEvent()
    }
  },
  watch: {
    'getIsMobile'(val) {
      val
        ? this.removeScrollEvent()
        : this.initScrollEvent()
    },
    'scroll_to_top'(val) {
      if (val || this.getIsMobile) return
      let component = this.$refs.language_switcher
      if (!component) return;
      component.changeShown(false)
    }
  }
}
</script>
